import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/marketing-pages.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';

//
Vue.prototype.$axios = axios;

//
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

